/**
 * Re-exports tslib and adds _objectWithoutPropertiesLoose (Babel's name for __rest)
 * so code that expects tslib._objectWithoutPropertiesLoose works (e.g. expo-router).
 * Static require path required for Metro.
 */
const tslib = require('tslib/tslib.js')

module.exports = {
  ...tslib,
  _objectWithoutPropertiesLoose: tslib.__rest,
}
